import {traceCallStatusCode} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/wfReactInterface/tsDataModelHooks';
import React from 'react';

import {CallsListSection} from './components/CallsListSection';
import {TraceItem} from './components/TraceItem';
import {EVALUATION_OP_NAME} from './constants';
import {
  calculateCallMetrics,
  calculateLatency,
  toOptionalMetric,
} from './utils';

interface RecentTracesProps {
  entityName: string;
  projectName: string;
}

export const RecentTraces: React.FC<RecentTracesProps> = ({
  entityName,
  projectName,
}) => {
  return (
    <CallsListSection
      entityName={entityName}
      projectName={projectName}
      title="Recent traces"
      viewAllPath="traces"
      query={{
        // Exclude evaluation traces (they have their own section)
        $expr: {
          $not: [
            {
              $contains: {
                input: {$getField: 'op_name'},
                substr: {$literal: EVALUATION_OP_NAME},
              },
            },
          ],
        },
      }}
      filter={{traceRootsOnly: true}}
      renderItem={call => {
        const {totalTokens, totalCost} = calculateCallMetrics(call);
        const latency = calculateLatency(
          call.traceCall?.started_at,
          call.traceCall?.ended_at
        );
        const status = traceCallStatusCode(call.traceCall);

        return (
          <TraceItem
            key={call.callId}
            callId={call.callId}
            spanName={call.spanName}
            displayName={call.displayName ?? undefined}
            startedAt={call.traceCall.started_at}
            latency={latency}
            status={status}
            tokens={toOptionalMetric(totalTokens)}
            cost={toOptionalMetric(totalCost)}
            userId={call.userId ?? undefined}
            entityName={entityName}
            projectName={projectName}
          />
        );
      }}
      emptyMessage="No traces yet"
      emptySubtitle="Traces from your runs will appear here"
      emptyIcon="running-repeat"
      emptyIconColor="text-teal-500"
      emptyIconBgGradient="from-teal-50 to-teal-100"
    />
  );
};
